export const setQueryParameter = (url, key, value) => {
  if (!url) return ""

  const [baseUrl, fragment] = url.split("#")

  const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
  const regex = new RegExp(`([?&]${escapedKey}=)[^&]+`)
  let result
  const encodedValue = encodeURIComponent(value)
  if (regex.test(baseUrl)) {
    result = baseUrl.replace(regex, `$1${encodedValue}`)
  } else {
    result = `${baseUrl}${baseUrl.includes("?") ? "&" : "?"}${key}=${encodedValue}`
  }

  return fragment ? `${result}#${fragment}` : result
}
